<template>
	<nav class="shortcutbar">
		<router-link to="/" class="shortcutbar-link logo-link"><img class="logo" src="/dist/logo_white.png" alt="logo"></router-link>
		<router-link to="/" class="shortcutbar-link"><i class="material-icons">home</i></router-link>
		<router-link to="/elements" class="shortcutbar-link"><i class="material-icons">view_list</i></router-link>
		<router-link class="shortcutbar-link" to="/Elementkit/overview"><i class="material-icons">widgets</i></router-link>
		<router-link class="shortcutbar-link" to="/spaces"><i class="material-icons">public</i></router-link>
	</nav>
</template>

<script>
export default {
	name: 'shortcutbar',
	components: {

	},
	data() {
		return {

		}
	}
}
</script>

<style lang="stylus">
.logo 
	max-width 100%
	height auto
.shortcutbar
	width: 60px
	position: fixed
	left: 0
	top: 0px
	height: 100vh
	padding-top: 0px
	background: linear-gradient(0deg, #2BA3CF, #22B6B4)
.shortcutbar-link
	display block
	color #fff
	text-align center
	padding 14px 16px 10px
	&.logo-link
		padding 10px 16px 4px
</style>



// WEBPACK FOOTER //
// Shortcutbar.vue?1a320e86